export function objectToArray(obj: any) {
  // Create an empty array to store the new objects
  var arr = [];

  // Loop through each key-value pair in the original object
  for (var key in obj) {
    // Create a new object with a "name" key and the original value
    var newObj = { name: obj[key] };

    // Add the new object to the array
    arr.push(newObj);
  }

  // Return the array of new objects
  return arr;
}
